module.exports = __webpack_public_path__ + "img/undraw_launch_day.c54747cb.svg";